var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRobber(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "700pt",
    height: "700pt",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m350 49.281c-102.48 0-185.36 82.879-185.36 185.36v276.08h370.72v-276.08c0-102.48-82.879-185.36-185.36-185.36zm-47.602 170.24 5.6016-11.199 0.55859-0.55859s0.55859 0 0.55859-0.55859c0.55859-0.55859 2.2383-1.6797 3.9219-1.6797h1.1211l0.55859 0.55859h1.1211c7.8398 4.4805 17.922 8.9609 30.238 8.9609 15.121 0 24.078-6.7188 24.641-17.922 0-11.199-7.8398-14.559-26.32-20.719-26.32-10.078-42-17.922-42-43.68 0-21.281 13.441-35.281 35.84-38.641v-16.801h19.602v15.68c9.5195 1.1211 19.602 4.4805 28 10.078 1.6797 0.55859 2.2383 1.6797 2.8008 2.8008 0.55859 1.6797 0 3.3594-0.55859 5.0391l-4.4805 11.199c-1.1211 2.2383-2.8008 3.3594-5.0391 3.9219-1.6797 0-2.8008 0-4.4805-1.1211-10.078-5.6016-19.039-8.3984-27.441-8.3984-7.8398 0-21.281 2.2383-21.281 16.801 0 11.199 8.3984 15.121 22.398 20.16l3.3594 1.1211c24.078 7.8398 42 15.68 42 41.441 0 21.84-12.879 36.961-35.84 40.879l0.003906 15.117h-18.48v-14.559c-12.32-1.6797-24.078-5.6016-33.602-11.199-1.6797-1.1211-2.8008-3.9219-2.8008-5.6016zm-97.438 6.7188c0.55859-7.2812 8.3984-11.199 14.559-7.8398l106.96 61.602c7.2812 4.4805 6.1602 15.68-2.2383 17.922-113.12 28.559-121.52-40.32-119.28-71.684zm211.12 212.24h-132.16c-9.5195 0-15.121-11.199-8.9609-18.48l66.078-84c4.4805-5.6016 13.441-5.6016 17.922 0l66.078 84c6.1602 7.8398 0.5625 18.48-8.9609 18.48zm-39.758-141.12c-8.3984-2.2383-10.078-13.441-2.2383-17.922l106.96-61.602c6.1602-3.3594 14 0.55859 14.559 7.8398 1.6797 31.926-6.7227 100.8-119.28 71.684z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m305.2 415.52c-1.1211 0-2.2383-0.55859-3.3594-1.1211-2.2383-1.6797-3.3594-5.0391-1.1211-7.8398 0.55859-1.1211 16.801-22.961 43.121-26.32 17.922-2.2383 35.84 5.0391 53.762 21.281 2.2383 2.2383 2.2383 5.6016 0.55859 7.8398-2.2383 2.2383-5.6016 2.2383-7.8398 0.55859-15.121-14-30.238-19.602-44.801-18.48-21.84 2.2383-35.281 21.281-35.281 21.281-1.6797 1.6797-3.3594 2.8008-5.0391 2.8008z"
  }), /*#__PURE__*/React.createElement("use", {
    x: 70,
    y: 644,
    xlinkHref: "#u"
  }), /*#__PURE__*/React.createElement("use", {
    x: 90.550781,
    y: 644,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 104.359375,
    y: 644,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 123.347656,
    y: 644,
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("use", {
    x: 142.242188,
    y: 644,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 155.628906,
    y: 644,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 174.617188,
    y: 644,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    x: 204.410156,
    y: 644,
    xlinkHref: "#k"
  }), /*#__PURE__*/React.createElement("use", {
    x: 224.453125,
    y: 644,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("use", {
    x: 252.453125,
    y: 644,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("use", {
    x: 274.011719,
    y: 644,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 293.25,
    y: 644,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("use", {
    x: 313.179688,
    y: 644,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    x: 333.117188,
    y: 644,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    x: 362.90625,
    y: 644,
    xlinkHref: "#t"
  }), /*#__PURE__*/React.createElement("use", {
    x: 373.324219,
    y: 644,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    x: 389.921875,
    y: 644,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 409.15625,
    y: 644,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    x: 429.09375,
    y: 644,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("use", {
    x: 70,
    y: 672,
    xlinkHref: "#r"
  }), /*#__PURE__*/React.createElement("use", {
    x: 82.183594,
    y: 672,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 95.992188,
    y: 672,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 115.226562,
    y: 672,
    xlinkHref: "#q"
  }), /*#__PURE__*/React.createElement("use", {
    x: 154.152344,
    y: 672,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 167.535156,
    y: 672,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 187.46875,
    y: 672,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 216.207031,
    y: 672,
    xlinkHref: "#o"
  }), /*#__PURE__*/React.createElement("use", {
    x: 239.640625,
    y: 672,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 258.878906,
    y: 672,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("use", {
    x: 278.8125,
    y: 672,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    x: 308.492188,
    y: 672,
    xlinkHref: "#n"
  }), /*#__PURE__*/React.createElement("use", {
    x: 329.015625,
    y: 672,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 342.820312,
    y: 672,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 362.058594,
    y: 672,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("use", {
    x: 371.65625,
    y: 672,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 390.648438,
    y: 672,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    x: 407.242188,
    y: 672,
    xlinkHref: "#c"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobber);
export default __webpack_public_path__ + "static/media/robber.e42321e1835d4849b7fcf657d532ae16.svg";
export { ForwardRef as ReactComponent };